import { z } from 'zod'

export const configSchema = z.strictObject({
  appName: z.string(),
  appVersion: z.string(),
})

export type Config = z.infer<typeof configSchema>
